import React from 'react';

const About: React.FC = () => {
  return (
    <div className="container-custom py-12 md:py-24">
      <h1 className="mb-8 text-center">About Us</h1>
      <div className="max-w-4xl mx-auto">
        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Yeremian Lifestyle Homes, a subsidiary of Georgia Diversified Services, has been operating in the construction industry since 2007. Starting as a subcontractor for major construction firms, GDS quickly gained a reputation for its quality and efficient services. Over time, GDS expanded its offerings through Yeremian Lifestyle Homes, specializing in residential building.
          </p>
          
          <p className="text-lg text-gray-700 mb-6">
            Today, Yeremian Lifestyle Homes is dedicated solely to residential construction and is renowned for creating quality and contemporary homes to fulfill the demands of modern families. With a team of seasoned professionals and a commitment to utilizing the latest technology and construction techniques, Yeremian Lifestyle Homes is fully capable of executing any residential building project with ease.
          </p>

          <div className="bg-primary/5 rounded-lg p-8 my-8">
            <h2 className="text-2xl font-serif mb-4">Our Commitment</h2>
            <p className="text-lg text-gray-700">
              As a division of the established GDS Construction, Yeremian Lifestyle Homes benefits from the parent company's extensive experience and prestige in the construction industry. We are committed to delivering innovative and stylish homes that meet the needs of modern families while maintaining the highest standards of quality and craftsmanship.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-12">
            <div className="text-center">
              <div className="text-primary text-4xl font-bold mb-2">2007</div>
              <div className="text-gray-600">Established</div>
            </div>
            <div className="text-center">
              <div className="text-primary text-4xl font-bold mb-2">15+</div>
              <div className="text-gray-600">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-primary text-4xl font-bold mb-2">100%</div>
              <div className="text-gray-600">Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 